import { MakeCall } from './createMakeCall';

const deleteListing = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/listing/${listingId}`);
export { deleteListing };
